export default __webpack_public_path__ + "static/media/img7.ac3a9533.png";